<template lang="pug">
  .component-policy-button
    .dropdown-buttons
      PolicyReveal(:policyProp="item")
      ActionButton(:action="remove") Delete

</template>

<script>
  import PolicyReveal from '../../../../pages/backoffice/PolicyReveal'
  import ModalReveal from '../../foundation/ModalReveal'
  import ActionButton from '../ActionButton'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../maggieHelper'

  export default {
    name: 'PolicyButtons',
    components: {PolicyReveal, ActionButton, ModalReveal},
    data() {
      return {}
    },
    created() {


    },

    methods: {
      remove() {
        return KeplerBackofficeSdk.policies.select(this.item).remove(() => {
          MaggieHelper.notification('', 'Policy deleted')
          location.reload()
          this.$emit('refresh')
        })
      }
    },

    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PolicyButtons.vue?68fe9381